import {Locale} from '@/utils/constants'
import {useLanguage} from '@/utils/i18n/language'
import {getRouteToPrivacyPolicy, routeTo} from '@/utils/router'

import {getContactContent} from './contact'
export const useFooterContent = () => {
  const language = useLanguage()
  const {phoneNumberByOffice} = getContactContent()
  const isEnLanguage = language === Locale.en
  const isSkLanguage = language === Locale.sk

  return {
    menu: [
      {
        title: 'footer-navigation-title',
        links: [
          {
            linkHref: routeTo.aboutUs.home(),
            linkText: 'footer-navigation-link-0',
            trackedEvent: 'Footer-AboutUs',
          },
          {
            linkHref: routeTo.pricing(),
            linkText: 'footer-navigation-link-1',
            trackedEvent: 'Footer-Pricing',
          },
          {
            linkHref: routeTo.faq(),
            linkText: 'footer-navigation-link-2',
            trackedEvent: 'Footer-FAQ',
          },
          {
            ...(isEnLanguage && {
              linkHref: routeTo.trademarkQA.home(),
              linkText: 'footer-navigation-link-4',
              trackedEvent: 'Footer-TrademarkQA',
            }),
          },
          {
            ...(isEnLanguage && {
              linkHref: routeTo.brandProtectionQA.home(),
              linkText: 'footer-navigation-link-6',
              trackedEvent: 'Footer-BrandProtectionQA',
            }),
          },
          {
            linkHref: routeTo.termsAndConditions(),
            linkText: 'footer-navigation-link-3',
            trackedEvent: 'Footer-ToS',
            prefetch: false,
          },
          {
            ...(isEnLanguage && {
              linkHref: routeTo.accountTermsAndConditions(),
              linkText: 'footer-navigation-link-7',
              trackedEvent: 'Footer-AccountToS',
              prefetch: false,
            }),
          },
        ],
      },
      {
        title: 'footer-services-title',
        links: [
          {
            linkHref: routeTo.verification.form(),
            linkText: 'footer-services-link-0',
            trackedEvent: 'Footer-Verification',
          },
          {
            linkHref: routeTo.brandMonitoring.home(),
            linkText: 'footer-services-link-4',
            trackedEvent: 'Footer-BrandProtection',
          },
          {
            linkHref: routeTo.legalServices(),
            linkText: 'footer-services-link-1',
            trackedEvent: 'Footer-IpServices',
          },
        ],
      },
    ],
    contact: {
      title: 'footer-contact-title',
      businessHours: 'footer-contact-business-hours',
    },
    paymentTitle: 'footer-payment-methods-title',
    offices: {
      title: 'footer-offices-title',
      list: [
        {
          country: 'UK',
          street: 'office-location-uk-address-0',
          city: 'office-location-uk-address-1',
          phoneNumber: phoneNumberByOffice.UK.default,
          phoneNumberHref: phoneNumberByOffice.UK.href,
        },
        {
          country: 'US',
          street: 'office-location-us-address-0',
          city: 'office-location-us-address-1',
          phoneNumber: phoneNumberByOffice.US.default,
          phoneNumberHref: phoneNumberByOffice.US.href,
        },
        {
          country: 'CA',
          street: 'office-location-ca-address-0',
          city: 'office-location-ca-address-1',
        },
        {
          country: 'EU',
          street: 'office-location-sk-address-0',
          city: 'office-location-sk-address-1',
          phoneNumber: phoneNumberByOffice.SK.default,
          phoneNumberHref: phoneNumberByOffice.SK.href,
        },
        {
          country: 'AU',
          street: 'office-location-au-address-0',
          city: 'office-location-au-address-1',
          phoneNumber: phoneNumberByOffice.AU.default,
          phoneNumberHref: phoneNumberByOffice.AU.href,
        },
      ],
    },
    partners: {
      title: 'footer-partners-title',
      list: [
        {
          imageSrc: '/images/partners/vacuumlabs-logo.svg',
          imageWidth: 123,
          imageHeight: 24,
          imageAlt: 'Vacuumlabs logo',
          linkHref: 'https://vacuumlabs.com',
        },
        {
          imageSrc: '/images/partners/sparring-logo.svg',
          imageWidth: 118,
          imageHeight: 30,
          imageAlt: 'Sparring logo',
          linkHref: 'https://sparring.io',
        },
        ...(isEnLanguage
          ? []
          : [
              {
                imageSrc: '/images/partners/shoptet-logo.svg',
                imageWidth: 71,
                imageHeight: 20,
                imageAlt: 'Shoptet logo',
                linkHref: isSkLanguage ? 'https://www.shoptet.sk' : 'https://www.shoptet.cz',
              },
            ]),
        {
          imageSrc: '/images/partners/eagle-labs-logo.svg',
          imageWidth: 81,
          imageHeight: 20,
          imageAlt: 'Eagle Labs Logo',
          linkHref: 'https://labs.uk.barclays',
        },
        {
          imageSrc: '/images/partners/saashub-logo.svg',
          imageWidth: 85,
          imageHeight: 20,
          imageAlt: 'SaaSHub Logo',
          linkHref: 'https://www.saashub.com/',
        },
        {
          imageSrc: '/images/partners/revolut-logo.svg',
          imageWidth: 52,
          imageHeight: 20,
          imageAlt: 'Revolut Logo',
          linkHref: 'https://www.revolut.com/',
        },
      ],
    },
    legal: [
      {
        linkHref: routeTo.legalNotice(),
        linkText: 'footer-legal-notice-title',
        trackedEvent: 'Footer-LegalNotice',
      },
      {
        linkHref: getRouteToPrivacyPolicy(language),
        linkText: 'footer-privacy-policy-title',
        trackedEvent: 'Footer-GDPR',
      },
    ],
    trustpilot: {
      description: 'page.footer-trustpilot-desc',
      imageSrc: '/images/trustpilot-logo.svg',
      imageAlt: 'Trustpilot logo',
      trackedEvent: 'Footer-Trustpilot',
    },
  }
}
